// extracted by mini-css-extract-plugin
export default {"badgeBody":"badgeBody--wXAWQ","error":"error--vT24g","warning":"warning--Pae0m","success":"success--Qp80a","gray":"gray--yO_JP","blue":"blue--HqtVG"};